function hasClass (el, cls) {
  return !!el.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

function addClass (el, cls) {
  if (!hasClass(el, cls)) {
    el.className += ' ' + cls
  }
}

function removeClass (el, cls) {
  if (hasClass(el, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    el.className = el.className.replace(reg, ' ')
  }
}

export default {
  bind (el, binding, vnode) {
    if (binding.value === false) {
      if (hasClass(el, 'disabled')) {
        removeClass(el, 'disabled')
      }
    } else {
      if (!hasClass(el, 'disabled')) {
        addClass(el, 'disabled')
      }
    }
  },

  update (el, binding, vnode) {
    if (binding.value === false) {
      if (hasClass(el, 'disabled')) {
        removeClass(el, 'disabled')
      }
    } else {
      if (!hasClass(el, 'disabled')) {
        addClass(el, 'disabled')
      }
    }
  },
}
